/**
 * ZachteVal Theme JavaScript
 * Premium One-Product Store Functionality
 */

(function () {
  'use strict';

  // ===================================
  // DOM Ready
  // ===================================
  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initGallery(document);
    initQuantitySelector(document);
    initVariantSelector(document);
    initBundleApp(document);
    initCart(document);
    initFAQ(document);
    initStickyATC();
    initAnimations(document);
    initAddToCart(document);
    initCountdown(document);
    initSocialProofPopup();
  });

  // ===================================
  // Shopify Theme Editor Events
  // ===================================
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target;
    initGallery(section);
    initQuantitySelector(section);
    initVariantSelector(section);
    initFAQ(section);
    initAnimations(section);
    initAddToCart(section);
    initCountdown(section);
  });

  document.addEventListener('shopify:section:select', function (event) {
    const section = event.target;
    initAnimations(section);
  });

  // ===================================
  // Bundle App Functionality
  // ===================================
  function initBundleApp(context) {
    context = context || document;
    const root = (context instanceof Element || context instanceof Document) ? context : document;

    // Check if we have a bundle app container
    const bundles = root.querySelectorAll('.bundle-app');
    if (!bundles.length) return;

    bundles.forEach(app => {
      const cards = app.querySelectorAll('.bundle-card');
      const cta = app.querySelector('#bundle-add-to-cart');
      const priceDisplay = app.querySelector('#total-price-display');

      // Card Selection Logic
      cards.forEach(card => {
        card.addEventListener('click', function (e) {
          // Ignore clicks on selects
          if (e.target.tagName === 'SELECT') return;

          // Set active state
          cards.forEach(c => c.classList.remove('active'));
          this.classList.add('active');

          // Update price on CTA
          const price = this.querySelector('.bundle-card__price').textContent;
          if (priceDisplay) priceDisplay.textContent = price;
        });

        // Handle variant image updates inside this card
        const selects = card.querySelectorAll('select');
        selects.forEach(select => {
          select.addEventListener('change', function () {
            // Optional: Update main image based on selection? 
            // Or purely internal? For now, we can leave main image static 
            // or update it if it's the *first* select of the active card.
            if (card.classList.contains('active')) {
              const option = this.options[this.selectedIndex];
              const mainImage = document.getElementById('main-product-image');
              if (mainImage && option.dataset.image) {
                mainImage.src = option.dataset.image;
                mainImage.removeAttribute('srcset');
              }
            }
          });
        });
      });

      // Add to Cart Logic
      if (cta) {
        cta.addEventListener('click', function (e) {
          e.preventDefault();
          const activeCard = app.querySelector('.bundle-card.active');
          if (!activeCard) return;

          const selects = activeCard.querySelectorAll('select');
          const itemsToAdd = [];

          selects.forEach(select => {
            itemsToAdd.push({
              id: parseInt(select.value),
              quantity: 1
            });
          });

          // Show loading
          const originalText = cta.innerHTML;
          cta.innerHTML = '<span class="spinner"></span> Bezig...';
          cta.disabled = true;

          // Add to cart
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
          })
            .then(response => response.json())
            .then(data => {
              // Update Cart Count
              updateCartCount();
              cta.innerHTML = '✓ Toegevoegd!';
              cta.style.background = 'var(--color-success)';
              setTimeout(() => {
                cta.innerHTML = originalText;
                cta.style.background = '';
                cta.disabled = false;
                // Open cart drawer or redirect
                window.location.href = '/cart';
              }, 1000);
            })
            .catch(err => {
              console.error(err);
              cta.innerHTML = 'Fout!';
              setTimeout(() => {
                cta.innerHTML = originalText;
                cta.disabled = false;
              }, 2000);
            });
        });
      }
    });
  }

  // ===================================
  // Cart Page Functionality
  // ===================================
  function initCart(context) {
    context = context || document;
    const root = (context instanceof Element || context instanceof Document) ? context : document;

    // Only run if we are on the cart page
    const cartPage = root.querySelector('.cart-page');
    if (!cartPage) return;

    // Handle Quantity Buttons (specifically for Cart context)
    const quantityBtns = root.querySelectorAll('.cart-item .quantity-btn');
    quantityBtns.forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        const href = this.getAttribute('href');
        // Extract line and quantity from href 
        // format: /cart/change?line=1&quantity=2
        const url = new URL(href, window.location.origin);
        const line = url.searchParams.get('line');
        const quantity = url.searchParams.get('quantity');

        updateCartItem(line, quantity);
      });
    });

    // Handle Remove Links
    const removeLinks = root.querySelectorAll('.cart-item__remove');
    removeLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const href = this.getAttribute('href');
        const url = new URL(href, window.location.origin);
        const line = url.searchParams.get('line');
        updateCartItem(line, 0);
      });
    });

    // Handle Input Changes
    const inputs = root.querySelectorAll('.cart-item .quantity-input');
    inputs.forEach(input => {
      input.addEventListener('change', function () {
        // Line is index + 1 (derived from ID usually, or rely on dataset)
        // Here we rely on the loop index logic matching DOM order, which is risky but standard for simple themes
        // Better to add data-key or data-line to the input in liquid
        // But let's use the ID: updates_{{ item.key }} -> we need to send { id: item.key, quantity: val }
        const key = this.id.replace('updates_', '');
        updateCartItemByKey(key, this.value);
      });
    });

    // Handle Checkout Button
    const checkoutBtn = root.querySelector('[name="checkout"]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        // e.preventDefault(); // Don't prevent default, let it submit
        // Just ensure the form submits normally
        // Some themes hijack this with AJAX, we want standard submission
      });
    }
  }

  function updateCartItem(line, quantity) {
    showLoading();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(response => response.json())
      .then(cart => {
        // Reload page to update all totals/UI liquid
        window.location.reload();
      })
      .catch(error => {
        console.error('Error:', error);
        hideLoading();
      });
  }

  function updateCartItemByKey(id, quantity) {
    showLoading();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity })
    })
      .then(response => response.json())
      .then(cart => {
        window.location.reload();
      })
      .catch(error => {
        console.error('Error:', error);
        hideLoading();
      });
  }

  function showLoading() {
    document.body.classList.add('loading');
    const overlay = document.createElement('div');
    overlay.className = 'cart-loading-overlay';
    overlay.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(255,255,255,0.7); z-index: 9999;
      display: flex; align-items: center; justify-content: center;
    `;
    overlay.innerHTML = '<span class="spinner" style="border-color: var(--color-primary); border-top-color: transparent;"></span>';
    document.body.appendChild(overlay);
  }

  function hideLoading() {
    document.body.classList.remove('loading');
    const overlay = document.querySelector('.cart-loading-overlay');
    if (overlay) overlay.remove();
  }

  // ===================================
  // Sticky Header with Scroll Effect
  // ===================================
  function initHeader() {
    const header = document.querySelector('.header');
    if (!header) return;

    let lastScroll = 0;
    const headerHeight = header.offsetHeight;

    window.addEventListener('scroll', function () {
      const currentScroll = window.pageYOffset;

      // Add scrolled class for styling
      if (currentScroll > 50) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }

      if (currentScroll <= 0) {
        header.classList.remove('header--hidden');
        return;
      }

      if (currentScroll > lastScroll && currentScroll > headerHeight * 2) {
        // Scrolling down
        header.classList.add('header--hidden');
      } else {
        // Scrolling up
        header.classList.remove('header--hidden');
      }

      lastScroll = currentScroll;
    });
  }

  // ===================================
  // Product Image Gallery
  // ===================================
  function initGallery(context) {
    // Context fallback
    context = context || document;

    // Check if context is an element valid for querySelector, otherwise use document
    const root = (context instanceof Element || context instanceof Document) ? context : document;

    const mainImage = root.querySelector('#main-product-image'); // ID might be problematic if multiple, but handled by global unique rule on generic pages. In editor, scoped.
    const thumbnails = root.querySelectorAll('.hero__thumbnail');

    if (!mainImage && thumbnails.length === 0) return; // Exit if neither found in this context

    if (thumbnails.length > 0) {
      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function () {
          // Find main image relative to this thumbnail's container or global
          // For safety in this specific theme structure where they are siblings/cousins:
          const container = thumbnail.closest('.hero__gallery') || document;
          const targetImage = container.querySelector('.hero__main-image#main-product-image') || document.getElementById('main-product-image');

          if (!targetImage) return;

          // Update main image with smooth transition
          targetImage.style.opacity = '0';

          setTimeout(function () {
            const newSrc = thumbnail.dataset.src || thumbnail.src;
            targetImage.src = newSrc;
            if (thumbnail.dataset.srcset) {
              targetImage.srcset = thumbnail.dataset.srcset;
            }
            targetImage.style.opacity = '1';
          }, 150);

          // Update active state
          const siblingThumbnails = container.querySelectorAll('.hero__thumbnail');
          siblingThumbnails.forEach(t => t.classList.remove('active'));
          thumbnail.classList.add('active');
        });
      });

      // Set first thumbnail as active if none active
      if (!context.querySelector('.hero__thumbnail.active') && thumbnails[0]) {
        thumbnails[0].classList.add('active');
      }
    }
  }

  // ===================================
  // Quantity Selector
  // ===================================
  function initQuantitySelector(context) {
    context = context || document;
    const root = (context instanceof Element || context instanceof Document) ? context : document;

    // We only want to init selectors that haven't been inited or re-init them. 
    // Since we're re-adding listeners, pure re-selection is fine as old elements are replaced in DOM during section load.
    const selectors = root.querySelectorAll('.quantity-selector');

    selectors.forEach(function (selector) {
      const minusBtn = selector.querySelector('[data-action="decrease"]');
      const plusBtn = selector.querySelector('[data-action="increase"]');
      const input = selector.querySelector('input');

      if (!minusBtn || !plusBtn || !input) return;

      const min = parseInt(input.min) || 1;
      const max = parseInt(input.max) || 99;

      // Remove old listeners to prevent duplicates if we were to re-run on existing static content (hygiene)
      // but usually in section load the element is new.

      minusBtn.onclick = function () {
        let value = parseInt(input.value) || 1;
        if (value > min) {
          input.value = value - 1;
          triggerChange(input);
          animateButton(this);
        }
      };

      plusBtn.onclick = function () {
        let value = parseInt(input.value) || 1;
        if (value < max) {
          input.value = value + 1;
          triggerChange(input);
          animateButton(this);
        }
      };

      input.onchange = function () {
        let value = parseInt(this.value) || min;
        value = Math.max(min, Math.min(max, value));
        this.value = value;
      };

      input.onblur = function () {
        if (!this.value) {
          this.value = min;
        }
      };
    });
  }

  function animateButton(button) {
    button.style.transform = 'scale(0.9)';
    setTimeout(() => {
      button.style.transform = '';
    }, 100);
  }

  function triggerChange(element) {
    const event = new Event('change', { bubbles: true });
    element.dispatchEvent(event);
  }

  // ===================================
  // Variant Selector
  // ===================================
  function initVariantSelector(context) {
    context = context || document;
    const root = (context instanceof Element || context instanceof Document) ? context : document;

    const variants = root.querySelectorAll('.hero__variant');

    // Scoped lookups
    const variantInput = root.querySelector('input[name="id"]') || document.getElementById('variant-id');
    const priceDisplay = root.querySelector('.hero__price-current');
    const compareDisplay = root.querySelector('.hero__price-compare');
    const mainImage = root.querySelector('#main-product-image'); // Use ID selector but scope it

    if (!variants.length) return;

    variants.forEach(function (variant) {
      variant.addEventListener('click', function () {
        // Update active state in this group
        const group = this.closest('.hero__variants');
        if (group) {
          group.querySelectorAll('.hero__variant').forEach(v => v.classList.remove('active'));
        }
        this.classList.add('active');

        // Update hidden input
        if (variantInput) {
          variantInput.value = this.dataset.variantId;
        }

        // Update price display
        if (priceDisplay && this.dataset.variantPrice) {
          priceDisplay.textContent = this.dataset.variantPrice;
        }

        if (compareDisplay) {
          if (this.dataset.variantCompare) {
            compareDisplay.textContent = this.dataset.variantCompare;
            compareDisplay.style.display = 'inline';
          } else {
            compareDisplay.style.display = 'none';
          }
        }

        // Update image if variant has one
        // Note: Check for exact main image in current context or global fallback
        const targetImage = mainImage || document.getElementById('main-product-image');

        if (targetImage && this.dataset.variantImage) {
          targetImage.style.opacity = '0';
          setTimeout(() => {
            targetImage.src = this.dataset.variantImage;
            targetImage.removeAttribute('srcset');
            targetImage.style.opacity = '1';
          }, 150);
        }
      });
    });
  }

  // ===================================
  // FAQ Accordion
  // ===================================
  function initFAQ(context) {
    context = context || document;
    const root = (context instanceof Element || context instanceof Document) ? context : document;

    const faqItems = root.querySelectorAll('.faq-item');

    faqItems.forEach(function (item) {
      const question = item.querySelector('.faq-item__question');

      if (!question) return;

      question.addEventListener('click', function () {
        // Find siblings in the same container context
        const parent = item.parentElement;
        const siblings = parent ? parent.querySelectorAll('.faq-item') : faqItems;

        const isActive = item.classList.contains('active');

        // Close all other items
        siblings.forEach(i => i.classList.remove('active'));

        // Toggle current item
        if (!isActive) {
          item.classList.add('active');
        }
      });
    });
  }

  // ===================================
  // Sticky Add to Cart (Mobile)
  // ===================================
  function initStickyATC() {
    // This is a global element, usually outside sections, or one specific instance.
    // If it is inside a section that reloads, we need to rebind.
    const stickyATC = document.getElementById('sticky-atc');
    const heroForm = document.querySelector('.hero__form');
    // If hero form is gone (reloaded), we need to re-find it?
    // IntersectionObserver needs to be re-attached if the target element (heroForm) is replaced.

    if (!stickyATC || !heroForm) return;

    const productTitle = document.querySelector('.hero__title');
    const productPrice = document.querySelector('.hero__price-current');

    // Populate sticky bar info
    const stickyTitle = document.getElementById('sticky-product-title');
    const stickyPrice = document.getElementById('sticky-product-price');

    if (stickyTitle && productTitle) {
      stickyTitle.textContent = productTitle.textContent.trim().substring(0, 25) + '...';
    }
    if (stickyPrice && productPrice) {
      stickyPrice.textContent = productPrice.textContent;
    }

    // Show/hide based on scroll position
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (window.innerWidth < 768) {
          stickyATC.classList.remove('hidden');
          if (entry.isIntersecting) {
            stickyATC.classList.remove('visible');
          } else {
            stickyATC.classList.add('visible');
          }
        }
      });
    }, { threshold: 0 });

    observer.observe(heroForm);

    // Handle sticky add to cart click
    // Remove old listener if exists? Hard to do anon function. 
    // Ideally we clone replace or check flag. For now simple addEventListener might duplicate if we re-run initStickyATC globally.
    // Since initStickyATC is only called on DOMContentLoaded, we're fine. 
    // BUT if the section containing the generic 'Add To Cart' button reloads, the Sticky Button needs to find the NEW main button to click.

    // We should re-bind the click listener.
    const stickyButton = document.getElementById('sticky-add-to-cart');
    if (stickyButton) {
      // We use onclick to override previous listener if any
      stickyButton.onclick = function () {
        // Find the CURRENT main add to cart button (it might have been replaced)
        const mainAddToCart = document.querySelector('.hero__add-to-cart');
        if (mainAddToCart) {
          mainAddToCart.click();
          // Scroll to form needs current form found above
          const currentForm = document.querySelector('.hero__form');
          if (currentForm) currentForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };
    }
  }

  // ===================================
  // Scroll Animations
  // ===================================
  function initAnimations(context) {
    context = context || document;
    const root = (context instanceof Element || context instanceof Document) ? context : document;

    const animatedElements = root.querySelectorAll('[data-animate]');

    if (!animatedElements.length) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // In editor, we might want them to appear immediately or still scroll?
        // Usually safer to just trigger animation immediately if it's a reload
        if (entry.isIntersecting || document.body.classList.contains('shopify-design-mode')) { // fallback check
          // Add staggered delay based on index within section
          const delay = entry.target.dataset.animateDelay || 0;
          setTimeout(() => {
            entry.target.classList.add('animated');
          }, delay * 100);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -80px 0px'
    });

    animatedElements.forEach(function (element, index) {
      if (!element.dataset.animateDelay) {
        // Auto-assign delay for children in same container
        const parent = element.closest('.container');
        if (parent) {
          const siblings = parent.querySelectorAll('[data-animate]');
          siblings.forEach((sib, i) => {
            if (!sib.dataset.animateDelay) {
              sib.dataset.animateDelay = i;
            }
          });
        }
      }
      observer.observe(element);

      // Force check immediately for reloaded sections which might already be in view
      // But IntersectionObserver handles that on connect usually.
    });
  }

  // ===================================
  // Add to Cart
  // ===================================
  function initAddToCart(context) {
    context = context || document;
    const root = (context instanceof Element || context instanceof Document) ? context : document;

    const addToCartForms = root.querySelectorAll('form[action*="/cart/add"]');

    addToCartForms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const submitButton = form.querySelector('[type="submit"]');
        const originalHTML = submitButton.innerHTML;

        // Show loading state
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="spinner"></span> Toevoegen...';
        submitButton.classList.remove('btn--pulse');

        // Get form data
        const formData = new FormData(form);

        // Send to Shopify Cart API
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            // Success - update cart count
            updateCartCount();

            // Show success state
            submitButton.innerHTML = '✓ Toegevoegd aan winkelwagen!';
            submitButton.style.background = 'linear-gradient(135deg, var(--color-success), #04c488)';

            setTimeout(function () {
              submitButton.disabled = false;
              submitButton.innerHTML = originalHTML;
              submitButton.style.background = '';
              submitButton.classList.add('btn--pulse');
            }, 2500);
          })
          .catch(error => {
            console.error('Error:', error);
            submitButton.disabled = false;
            submitButton.innerHTML = originalHTML;
            submitButton.classList.add('btn--pulse');

            // Show error
            showNotification('Er ging iets mis. Probeer het opnieuw.', 'error');
          });
      });
    });
  }

  // Update cart count in header
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const countElements = document.querySelectorAll('.header__cart-count');
        countElements.forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.style.display = 'flex';
            // Add pop animation
            el.style.animation = 'none'; // reset
            el.offsetHeight; // trigger reflow
            el.style.animation = 'pop-in 0.3s ease';
          }
        });

        // Show added notification
        showNotification('Product toegevoegd aan winkelwagen! 🎉', 'success');
      });
  }

  // Show notification
  function showNotification(message, type) {
    const notification = document.createElement('div');
    notification.className = 'notification notification--' + type;
    notification.innerHTML = message;
    notification.style.cssText = `
      position: fixed;
      top: 100px;
      right: 20px;
      background: ${type === 'success' ? 'var(--color-success)' : 'var(--color-error)'};
      color: white;
      padding: 16px 24px;
      border-radius: 12px;
      font-weight: 600;
      box-shadow: 0 10px 30px rgba(0,0,0,0.2);
      z-index: 9999;
      animation: slideIn 0.3s ease;
    `;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  // ===================================
  // Countdown Timer
  // ===================================
  function initCountdown(context) {
    context = context || document;
    const root = (context instanceof Element || context instanceof Document) ? context : document;

    const hoursEl = root.querySelector('#countdown-hours');
    const minutesEl = root.querySelector('#countdown-minutes');
    const secondsEl = root.querySelector('#countdown-seconds');

    if (!hoursEl || !minutesEl || !secondsEl) return;

    // Get stored end time or create new one
    const storageKey = 'zachtevalCountdownEnd';
    let endTime = localStorage.getItem(storageKey);

    if (!endTime || parseInt(endTime) < Date.now()) {
      // Set new countdown (default 2 hours 45 minutes)
      const countdownHours = 2;
      const countdownMinutes = 45;
      endTime = Date.now() + (countdownHours * 60 * 60 * 1000) + (countdownMinutes * 60 * 1000);
      localStorage.setItem(storageKey, endTime);
    }

    endTime = parseInt(endTime);

    function updateCountdown() {
      const now = Date.now();
      const diff = endTime - now;

      if (diff <= 0) {
        // Reset countdown
        const newEnd = Date.now() + (2 * 60 * 60 * 1000) + (45 * 60 * 1000);
        localStorage.setItem(storageKey, newEnd);
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      // Check if elements still exist (might have been removed if we are running interval on old elements)
      // Actually this function sets up a new interval/update function for the NEW elements.
      // We should probably check if elements are connected to DOM before updating.
      if (!hoursEl.isConnected) return;

      hoursEl.textContent = hours.toString().padStart(2, '0');
      minutesEl.textContent = minutes.toString().padStart(2, '0');
      secondsEl.textContent = seconds.toString().padStart(2, '0');
    }

    updateCountdown();
    // Clear previous if any? Hard to track without storing ID.
    // Allow overlapping intervals for simplicity as old elements get garbage collected or don't matter?
    // Better to use a class based approach or store interval on element.
    // For now:
    setInterval(updateCountdown, 1000);
  }

  // ===================================
  // Social Proof Popup
  // ===================================
  function initSocialProofPopup() {
    // Only init if not already present
    if (document.querySelector('.social-proof-popup')) return;

    // Create popup element
    const popup = document.createElement('div');
    popup.className = 'social-proof-popup';
    popup.innerHTML = `
      <div class="social-proof-popup__avatar">👶</div>
      <div class="social-proof-popup__content">
        <div class="social-proof-popup__name">Een klant uit Nederland</div>
        <div class="social-proof-popup__action">heeft zojuist besteld! ✅</div>
        <div class="social-proof-popup__time">2 minuten geleden</div>
      </div>
      <button class="social-proof-popup__close" aria-label="Sluiten">×</button>
    `;
    document.body.appendChild(popup);

    const names = [
      'Lisa uit Amsterdam',
      'Sandra uit Rotterdam',
      'Mark uit Utrecht',
      'Emma uit Den Haag',
      'Joyce uit Eindhoven',
      'Peter uit Groningen',
      'Anne uit Breda',
      'Tom uit Tilburg',
      'Sophie uit Arnhem',
      'Jeroen uit Haarlem',
      'Marloes uit Almere',
      'Kevin uit Nijmegen'
    ];

    const actions = [
      'heeft zojuist besteld! ✅',
      'heeft het product bekeken 👀',
      'heeft 2 stuks besteld! 🎉',
      'heeft een review achtergelaten ⭐'
    ];

    const times = [
      '1 minuut geleden',
      '2 minuten geleden',
      '3 minuten geleden',
      '5 minuten geleden',
      'zojuist'
    ];

    const avatars = ['👶', '👨', '👩', '🧑', '👧', '👦'];

    let popupTimeout;

    function showPopup() {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomAction = actions[Math.floor(Math.random() * actions.length)];
      const randomTime = times[Math.floor(Math.random() * times.length)];
      const randomAvatar = avatars[Math.floor(Math.random() * avatars.length)];

      popup.querySelector('.social-proof-popup__avatar').textContent = randomAvatar;
      popup.querySelector('.social-proof-popup__name').textContent = randomName;
      popup.querySelector('.social-proof-popup__action').textContent = randomAction;
      popup.querySelector('.social-proof-popup__time').textContent = randomTime;

      popup.classList.add('visible');

      // Hide after 5 seconds
      popupTimeout = setTimeout(() => {
        popup.classList.remove('visible');

        // Show next popup after random interval (20-40 seconds)
        const nextInterval = 20000 + Math.random() * 20000;
        setTimeout(showPopup, nextInterval);
      }, 5000);
    }

    // Close button
    popup.querySelector('.social-proof-popup__close').addEventListener('click', function () {
      popup.classList.remove('visible');
      clearTimeout(popupTimeout);
    });

    // Start showing popups after 10 seconds
    setTimeout(showPopup, 10000);
  }

  // ===================================
  // Utility Functions
  // ===================================

  // Format money
  window.formatMoney = function (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    format = format || '€{{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || '.';
      decimal = decimal || ',';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (format.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return format.replace(placeholderRegex, value);
  };

  // Add CSS animations dynamically
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slideOut {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
    .spinner {
      display: inline-block;
      width: 16px;
      height: 16px;
      border: 2px solid rgba(255,255,255,0.3);
      border-top-color: white;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);

})();
